<template>
  <div class="x-misscenlist-box" style="margin:15px">
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick" class="x-miss-tabbox">
      <el-tab-pane label="任务列表" name="first"> -->
        <div class="x-miss-addbox"><el-button type="primary" @click="addadd"  style="padding:15px;"><span class="x-ac-addbtn"></span>添加任务</el-button></div>
        <el-table :data="misslist" style="width: 100%" @selection-change="handleRowChange" ref="multipleTable" @row-click="clickrow" border>
          <el-table-column label="任务名称" width="">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="任务分配" width="">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.structure }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="">
            <template slot-scope="scope">
              <router-link :to="{name:'missioncenterlist',params:{missid:scope.row.id,misstitle:scope.row.title}}" @click.stop="see(scope.row.id)" class="x-text-see">查看</router-link>
              <span class="x-bianji" @click="editmission(scope.row)">修改</span>
              <span @click.stop="removetablelist(scope.row.id,scope.row.title,'1')" class="x-ac-remove">删除</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="完成情况" width="">
            <template slot-scope="scope">
              <span style="margin-left: 10px" @click.stop="see(scope.row.id)">查看</span>
              <router-link :to="{name:'missioncenterlist',params:{missid:scope.row.id,misstitle:scope.row.title}}" @click.stop="see(scope.row.id)" class="x-text-see">查看</router-link>
            </template>
          </el-table-column> -->
        </el-table>
        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="misslist.length"
          background
          class="x-pagination">
        </el-pagination> -->
      <!-- </el-tab-pane> -->
    </el-tabs>
    <!--添加任务-->
    <el-dialog title="添加任务" :visible.sync="addmisstoast" class="x-addb-hed" :close-on-click-modal='noshowmodal' :before-close="closeremove">
      <div class="x-addclass-box">
        <el-form ref="addmissform" :model="addmissform" :rules="ruleFrom" label-width="80px">
          <el-form-item label="任务名称" prop="name">
            <el-input v-model="addmissform.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="任务时间" prop="starttime">
            <el-date-picker
              v-model="addmissform.starttime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="学习课程" prop="classarray">
            <el-select v-model="addmissform.classarray" placeholder="请选择课程分类" @change="addchoiceclass" style="width:140px;">
              <el-option :label="item.title" :value="item.id" v-for="item in addchoiceclasslist" :key="item.id" ></el-option>
            </el-select>
            <el-select v-model="addmissform.classarraytwo" placeholder="请选择课程" style="width:340px;" value-key="id" @change="selectGet">
              <el-option :label="item.title" :value="item" v-for="(item,index) in addchoiceclasslisttwo" :key="item.id" :value-key="item.id"></el-option>
            </el-select>
            <!-- <el-button type="text" class="x-perli-item x-font-danger" @click="finishclass">完成</el-button> -->
          </el-form-item>

          <el-table :data="selectchecktitle" style="width: 100%;padding-left:80px;margin-bottom:20px" v-show="isshowclassarraytable" row-key="id" @update="datadragEnd" :span-method="arraySpanMethod">
            <el-table-column prop="date" label="课程排序" width="130" type="index"></el-table-column>
            <el-table-column prop="date" label="课程名称" width="130">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.title }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="date" label="学习周期" width="130">
              <template slot-scope="scope">
                <el-input  class="x-input-box" clearable placeholder="请输入" v-model="selectchecktitle[scope.$index].interval" size="mini" style="border-color:red;width:70px;"></el-input>
                <span>天</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="name" label="操作" width="130" type="index">
              <template slot-scope="scope">
                <span style="margin-left: 10px;cursor: pointer;" @click="removeclassarraytable(scope.$index)">删除</span>
              </template>
            </el-table-column>
          </el-table>

          <el-form-item label="学习权限" prop="" required>
            <el-select v-model="addmissform.regiontwo" clearable placeholder="请选择" size="medium" multiple value-key="id" v-show="noshow">
              <el-option v-for="item in showclasslistregiontwo" :key="item.id" :label="item.title" :value="item.id"></el-option>
            </el-select>
            <div class="x-addclass-box">
              <div class="custom-tree-container">
                <el-tree :data="treedata" :default-expand-all='isshowexpand' :check-strictly='parentcheck' show-checkbox node-key="id" ref="treeeditref" highlight-current :props="defaultProps" @check-change="handleCheckChange" :default-checked-keys="treechecknow" :default-expanded-keys="treeexpanded"></el-tree>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="培训班" prop="" required>
            <el-select v-model="addmissform.train" placeholder="请选择" clearable>
              <el-option
                v-for="item in traindata"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证书名称" prop="cert">
            <el-input v-model="addmissform.cert" clearable></el-input>
          </el-form-item>
          <el-form-item label="上传证书" class="x-css-label" required>
            <el-upload
            class="avatar-uploader"
            ref="upload"
            :on-success="myUpload"
            :before-upload="beforeAvatarUpload"
            :on-exceed="nomore"
            action="http://peixun.dlbbdk.com/upload/oss"
            :limit="1" :file-list="fileListImage"
            accept="image/jpeg,image/png,image/jpg"
            list-type="picture-card">
              <img src="imageUrl" class="avatar" v-if="imageUrl">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">建议文件尺寸400*550</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" v-if="isshoweditbtn">
        <el-button type="primary" @click="submitForm('addmissform')">添加任务</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button type="primary" @click="changemiss">修改任务</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import Sortable from 'sortablejs'
export default {
  name: 'missioncenter',
  data () {
    return {
      activeName:'first',
      activeNameTwo:'firstTwo',
      tableData:[],
      misslist:[],
      misslistid:'',
      currentPage:1,//默认显示第几页
      pagesize:20,//每页个数
      showclasslist:[],
      repeatlist:'',
      positionlist:'',
      tabcss:true,
      addmisstoast:false,
      addmissform:{
        name:'',
        starttime:[],
        classarray:'',
        classarraytwo:'',
        cert:'',
        regiontwo:[],
        train:''
      },
      ruleFrom:{
        name:[
          {required:true,message:'请输入任务标题',trigger:'blur'}
        ],
        starttime:[
          {required:true,message:'请选择起止时间',trigger:'blur'}
        ],
        classarray:[
          {required:true,message:'请选择课程',trigger:'blur'}
        ],
        cert:[
          {required:true,message:'请输入证书名称',trigger:'blur'}
        ]
      },
      addmissref:{
        name:'',
        starttime:'',
        classarray:'',
        cert:''
      },
      addchoiceclasslist:'',
      addchoiceclasslisttwo:'',

      begintime:'',
      overtime:'',
      fileListImage:[],
      imgossurl:'',
      imageUrl:'',
      rightlistfirstid:'',
      searchuser:'',
      company:localStorage.company,
      usertitle:'',
      showclasslistregiontwo:'',
      classarraytable:[],
      isshowclassarraytable:false,
      tablecan:[],
      i:'',
      selectcheckid:[],
      selectchecktitle:[],
      editlistdata:'',
      exidid:'',
      isshoweditbtn:false,
      treedata:[],
      defaultProps: {
        children: '_child',
        label: 'title'
      },
      noshow:false,
      treechecknow:[],
      treeexpanded:[],
      noshowmodal:false,
      selectOrg: {
        orgsid: []
      },
      parentcheck:false,
      isshowexpand:true,
      innerVisible:false,
      noshowmodal:false,
      subsetname:'',
      isdisabled:false,
      subsetnoname:false,
      innerVisibletwo:false,
      newname:'',
      nonewname:'',
      addbranch:false,
      departmenttreeexpanded:[],
      edit:false,
      userfineshid:'',
      traindata:''
    }
  },
  created() {
    this.misslistfun()//任务列表
    // this.repeatlistfun()//组织列表
    // this.positionlistfun()//角色列表
    // this.positionlistregi()//加载部门列表
    // this.rowDrop()
  },
  mounted(){
    this.addchoiceclass()//添加任务待选课程分类
    this.tree()
    this.trainlist()//培训班列表
  },
  methods:{
    //培训班列表
    trainlist:function(){
      axios.get('/admin/temp/list', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.traindata = response.data.data.list;//table数据源
            //加载列表
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    clicktree(data,node,my){
      // console.log(data);
      // console.log(node);
      // console.log(my);
      this.allmainproloading = true;
      this.userfinishlisttwo(data.id)
    },
    renderContent(h, { node, data, store }) {
        return (
          <span class="custom-tree-node">
            <span>{node.label}</span>
            <span>
              <el-button size="mini" type="text" on-click={ () => this.treeappend(data) }>添加</el-button>
              <el-button size="mini" type="text" on-click={ () => this.treeedit(node, data) }>编辑</el-button>
              <el-button size="mini" type="text" on-click={ () => this.treeremove(node, data) }>删除</el-button>
            </span>
          </span>);
    },
    // 编辑树2
    changetreename(){
      if(this.newname == ''){
        this.nonewname = true;
      }else{
        this.nonewname = false;
        // this.addclassloading=true;
        axios.get('/admin/organization/edit', {
          params: {
            sec: localStorage.token,
            id:this.treedeitid,
            title:this.newname
          }
        })
        .then(function (response) {
          console.log(response);
          if(response.data.status == 1){
            // this.addbranch = false;
            // this.addclassloading = false;
            //   this.ischangebtn = false;
            //   this.isdisabled = true
              this.$message({
                showClose: true,
                message: '修改部门成功',
                type: 'success'
              });
              this.classlist()
              this.tree()
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    // 添加三级分类
    addsubset(){
      this.innerVisible=false;
      if(this.subsetname == ''){
        this.subsetnoname = true;
      }else{
        this.subsetnoname = false;
        // this.addclassloading=true;
        axios.get('/admin/organization/add', {
          params: {
            sec: localStorage.token,
            title:this.subsetname,
            parentId:this.treeappendid
          }
        })
        .then(function (response) {
          console.log(response);
          if(response.data.status == 1){
            this.addclassloading = false;
              // this.formtwo.position = '';
              this.$message({
                showClose: true,
                message: '添加职位成功',
                type: 'success'
              });
              this.subsetname=''//清空输入框
              this.departlistthree(this.departid)//父级id
              this.tree()
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    // 添加任务 清空
    addadd(){
      this.addmisstoast=true;//显示添加任务
      this.selectchecktitle=[];//table数据源
      this.selectcheckid=[];//选择课程时 选中的id
      this.addmissform.cert='';//证书名称
      this.fileListImage=[];//证书图片文件
      this.addmissform.regiontwo=[];
      //
      this.addmissform.starttime='';
      this.isshowclassarraytable=false;//隐藏表格
      this.addmissform.classarraytwo='';
      this.addmissform.classarray='';//////////////
      this.isshoweditbtn=true;
      this.addmissform.name=''
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {//当前行row、当前列column、当前行号rowIndex、当前列号columnIndex
      // console.log(row);
      // console.log(column);
      // console.log(rowIndex);
      // console.log(columnIndex);
      // if (rowIndex % 2 === 0) {
      //   if (columnIndex === 0) {
      //     return [1, 2];
      //   } else if (columnIndex === 1) {
      //     return [0, 0];
      //   }
      // }
    },
    // 关闭弹窗 销毁树
    closeremove(){
      this.$nextTick(() => {
      	this.$refs.treeeditref.setCheckedKeys([]);
      });
      this.addmisstoast=false
    },
    //
    handleCheckChange(data, checked, indeterminate){
      console.log('数据:',data,'选中状态:',checked,'子树中选中状态:',indeterminate)
      const indexs = this.addmissform.regiontwo.indexOf(data.id);
      console.log(indexs);//-1 没包含
      // const indexnum = data._child.length;
      // console.log(indexnum);
      var that = this;
      console.log(data.id);
      // that.addmissform.regiontwo=[]
      // console.log(data._child.length);
      // if(checked){
      //   if(data._child){//有子集
      //     for(var i=0;i<data._child.length;i++){
      //       if(that.addmissform.regiontwo.indexOf(data._child[i].id)){//如果没有
      //         console.log('没有这个id'+i);
      //         console.log(that.addmissform.regiontwo.indexOf(data._child[i].id));
      //
      //         that.addmissform.regiontwo.push(data._child[i].id)
      //       }else{
      //         console.log(that.addmissform.regiontwo);
      //         console.log(data._child[i].id);
      //         console.log('已经有这个id了');
      //       }
      //
      //     }
      //   }else{
      //     that.addmissform.regiontwo.push(data.id)
      //   }
      //
      // }else{
      //   that.addmissform.regiontwo.splice(indexs,indexnum)
      // }
      // ////////////////////////////////////////////
      if(checked && indexs<0){
        console.log(that.addmissform.regiontwo);
        that.addmissform.regiontwo.push(data.id)
      }else if(!checked && indexs>=0){
        that.addmissform.regiontwo.splice(indexs,1)
      }

      console.log("传参用id:"+that.addmissform.regiontwo);
    },
    // 树 数据源
    tree(){
      axios.get('/admin/structure/treeList', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data.list);
            this.treedata = response.data.data.list
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //行拖拽
    datadragEnd (evt) {
        evt.preventDefault();
        console.log('拖动前的索引 :' + evt.oldIndex)
        console.log('拖动后的索引 :' + evt.newIndex)
        console.log(this.colors);
    },
    rowDrop() {
      // console.log('做拽');
      // const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
      // Sortable.create(el, {
      //     disabled: !this.enableDrag,
      //     ghostClass: 'sortable-ghost',
      //     setData: function(dataTransfer) {
      //         dataTransfer.setData('Text', '');
      //     },
      //     onEnd: (evt) => {
      //
      //     }
      // })
    },
    //下拉框选中事件
    selectGet(vId){//选中值的所有信息
      console.log(this.addmissform.classarraytwo.length);
      console.log(this.selectchecktitle.length);
      console.log(vId);
      console.log(Number(Math.random().toString().substr(3,length) + Date.now()).toString(36));
      this.isshowclassarraytable = true;//显示表格
      console.log(this.exidid);
      if(this.selectcheckid.includes(vId.id)) {
          //则包含该元素
          this.$message({
            showClose: true,
            message:'该课程已经添加' ,
            type: 'error'
          });
      }else{
        this.selectchecktitle.push({//table数据源
          'title':vId.title,//被选中所有title
          'id':Number(Math.random().toString().substr(3,length) + Date.now()).toString(36),
          'remoreid':vId.id
        })
        this.selectcheckid.push(vId.id)//被选中所有id
      }
      // if(this.exidid==''){//从添加打开
      //   for(let i=0; i<vId.length; i++) {
      //       console.log(this.selectcheckid[i]);
      //       console.log(vId[i].id);
      //       if(this.selectcheckid[i] == vId[i].id) {
      //           //则包含该元素
      //           this.$message({
      //             showClose: true,
      //             message:'该课程已经添加' ,
      //             type: 'error'
      //           });
      //       }else{
      //           this.selectcheckid.push(vId[i].id)//被选中所有id
      //           this.selectchecktitle.push({//table数据源
      //             'title':vId[i].title,//被选中所有title
      //             'id':Number(Math.random().toString().substr(3,length) + Date.now()).toString(36)
      //           })
      //       }
      //   }
      // }else{//从编辑打开
      //   console.log(this.tablecan.length);
      //     this.tablecan.push({
      //       'no':this.addmissform.classarraytwo.length+1,
      //       'course_id':vId[0].id,
      //       'title':vId[0].title
      //     });
      // }
      // this.selectcheckid=[]
      // this.selectchecktitle=[]

      // for(var i=0;i<vId.length;i++){
      //   this.selectcheckid.push(vId[i].id)//被选中所有id
      //   this.selectchecktitle.push({//table数据源
      //     'title':vId[i].title//被选中所有title
      //   })
      // }
      console.log(this.selectcheckid);//选中值的id
      console.log(this.selectchecktitle);//选中值的title
      // this.rowDrop()

    },
    //完成
    finishclass(){
      console.log(this.addmissform.classarraytwo);
      console.log(this.addmissform.classarraytwo[0]);
      console.log(this.addmissform.classarraytwo.length);
      this.classarraytable = []//表格数据源
      this.isshowclassarraytable = true;//显示表格
      for( var i=0;i<this.addmissform.classarraytwo.length;i++){
        this.classarraytable.push({
          'no':i+1,
          'title':this.addmissform.classarraytwo[i],
          'course_id':this.addmissform.classarraytwo[i],
          'id':(Math.random()*10000000).toString(16).substr(0,4)+'-'+(new Date()).getTime()+'-'+Math.random().toString().substr(2,5)
        });
      }
      console.log(this.classarraytable);
      // this.rowDrop()
    },
    removeclassarraytable(esd,xcv){
      console.log(esd);

      this.selectchecktitle.splice(esd,1)
      this.selectcheckid.splice(esd,1)
      console.log(this.selectcheckid);
      console.log(this.selectchecktitle);
    },
    //添加任务待选课程select
    addchoiceclass(checkedid){
      console.log(checkedid);
      this.addmissform.classarraytwo = ''
      console.log(this.addmissform.classarray);
      axios.get('/admin/cate/list', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            // console.log(response.data.data);
            // if(this.addmissform.classarray != ''){
            //   this.addchoiceclasslisttwo = response.data.data.list;//部门列表数据
            //   console.log(this.addchoiceclasslisttwo);
            // }else{
              this.addchoiceclasslist = response.data.data;//部门列表数据
              if(checkedid==undefined){
                checkedid = response.data.data.list[0].id;
              }
              this.classlistlidata(checkedid)
            // }
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 课程展示
    classlistlidata(id){
      console.log(id);
      axios.get('/admin/course/list', {
        params: {
          sec: localStorage.token,
          cateId:id
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.addchoiceclasslisttwo = response.data.data;
        }else{
          this.allmainproloading = false;
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 验证添加任务
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addmissfun()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 职位列表
    positionlistregi(){
      axios.get('/admin/organization/jobList', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data.list);
            this.showclasslistregiontwo = response.data.data;//部门列表数据
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 添加任务
    addmissfun(){
      console.log(this.addmissform.classarraytwo.length);
      console.log(this.selectchecktitle.length);
      this.tablecan = []
      for(var i=0;i<this.selectchecktitle.length;i++){
        if(this.selectchecktitle[i].interval==undefined){
          this.selectchecktitle[i].interval='0'
        }
        console.log(this.selectchecktitle[i].interval);
        this.tablecan.push({
          'no':i+1,
          'course_id':this.selectcheckid[i],
        });
      }
      console.log(this.addmissform.starttime);
      let starttime = this.addmissform.starttime[0]
      let endtime = this.addmissform.starttime[1]
      //时间转时间戳
     var date = new Date(starttime);
     this.begintime = Date.parse(date) / 1000;
     console.log('任务期限开始时间戳：'+this.begintime);

      var date2 = new Date(endtime);
      this.overtime = Date.parse(date2) / 1000;
      console.log('任务期限结束时间戳：'+this.overtime);

      console.log(this.tablecan);
      console.log(this.addmissform.classarraytwo);
      console.log(this.addmissform.regiontwo);
      console.log('培训班：'+this.addmissform.train);
      // this.closeremove()//销毁树
      axios.get('/admin/task/add', {
        params: {
          sec: localStorage.token,
          title:this.addmissform.name,
          startTime:this.begintime,
          endTime:this.overtime,
          course:JSON.stringify(this.tablecan),
          icon:this.imgossurl,
          iconName:this.addmissform.cert,
          sids:this.addmissform.regiontwo,//部门id
          tid:this.addmissform.train
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.addmisstoast = false;
            this.misslistfun()//任务列表
            this.$message({
              showClose: true,
              message: '添加任务成功',
              type: 'success'
            });
            // 清空表单数据
            this.addmissform.name = '';
            this.addmissform.starttime = '';
            this.addmissform.classarray = '';
            this.addmissform.classarraytwo = '';
            this.addmissform.cert = '';
            this.fileListImage = [];
            this.$refs[addmissform].resetFields();
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    myUpload(res,content){
      console.log(res);
      if(res.status == 1){
        console.log(res.data[0].url);
        this.imgossurl = res.data[0].url;
      }
    },
    beforeAvatarUpload(){

    },
    addmiss(){

    },
    // 组织对应列表
    changegroup(groupid,grouptitle,groupcount){
      this.rightlistfirstid = groupid;
      this.usertitle = grouptitle + '('+groupcount + ')人'
      this.userfinishlist()
    },
    // 角色对应列表
    changerole(groupid,grouptitle,groupcount){
      this.rightlistfirstid = groupid;
      this.usertitle = grouptitle + '('+groupcount + ')人'
      this.userfinishlisttwo()
    },
    // 上传超过限制
    nomore(){
      this.$message({
        showClose: true,
        message:'不好意思，超过限制啦！' ,
        type: 'error'
      });
    },
    // 任务列表
    misslistfun(){
      axios.get('/admin/task/list', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data);
            this.misslist = response.data.data;//部门列表数据
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    handleClick(){

    },
    handleClicktwo(esc,ass,index){
      console.log(index);
      console.log('点上了吗');
    },
    handleRowChange(){

    },
    clickrow(rowid){

    },
    see(misslistid){
      console.log(misslistid);

    },
    edittablelist(){

    },
    // 删除任务
    removetablelist(missionid,missiontitle){
      this.$confirm('确定要删除“'+missiontitle+'”吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/admin/task/del', {
            params: {
              sec: localStorage.token,
              id:missionid
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              this.misslistfun()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
        }).catch(() => {

        });
    },
    handleCurrentChange(val){
      console.log(`当前页: ${val}`);
    },
    // 组织列表
    repeatlistfun(){
      axios.get('/admin/task/department', {
        params: {
          sec: localStorage.token}
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data.list);
            this.repeatlist = response.data.data.list;//部门列表数据
            this.rightlistfirstid = response.data.data.list[0].id;//第一个组织的id
            this.usertitle = response.data.data.list[0].title+'('+response.data.data.list[0].count+')人';
            this.userfinishlist()
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 角色列表
    positionlistfun(){
      axios.get('/admin/task/job', {
        params: {
          sec: localStorage.token}
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data.list);
            this.positionlist = response.data.data.list;//部门列表数据
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 学员列表 部门
    userfinishlist(userfineshid){
      console.log('学员完成情况人员列表id：'+userfineshid);
      axios.get('/admin/task/departmentItems', {
        params: {
          sec: localStorage.token,
          id:userfineshid
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data.list);
            this.tableData = response.data.data.list;
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 查询全部人员
    allperson(){
      this.allmainproloading = true;
      this.userfinishlist()
    },
    // 学员列表 角色
    userfinishlisttwo(userfineshid){
      console.log(userfineshid);
      if(userfineshid){
        this.rightlistfirstid=userfineshid
      }
      console.log(this.rightlistfirstid);
      axios.get('/admin/task/jobItems', {
        params: {
          sec: localStorage.token,
          id:userfineshid
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data.list);
            this.tableData = response.data.data.list;
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 从编辑打开
    editmission(row){
      var that=this;
      that.isshoweditbtn=false
      console.log(row);
      that.tree()
      // axios.get('/admin/task/find', {
      //   params: {
      //     sec: localStorage.token,
      //     id:id
      //   }
      // })
      // .then(function (response) {
      //   console.log(response);
      //   if(response.data.status == 1){
            that.addmisstoast=true;
            that.editlistdata=row;
            // 从编辑打开
            console.log(that.editlistdata);
            console.log(this.tablecan);

            that.addmissform.name=that.editlistdata.title;//任务名称赋值

            that.addmissform.starttime=[]
            var timersstart = that.editlistdata.start_time;
            this.begintime=timersstart//开始时间赋值
            var timersend = that.editlistdata.end_time;
            this.overtime=timersend//结束时间赋值
            var datestart = new Date((parseInt(timersstart) + 8 * 3600) * 1000).toJSON().substr(0, 10).replace('T', ' ').replace(/-/g, '-');//开始日期
            var dateend = new Date((parseInt(timersend) + 8 * 3600) * 1000).toJSON().substr(0, 10).replace('T', ' ').replace(/-/g, '-');//开始日期
            console.log(that.addmissform.starttime);
            that.addmissform.starttime.push(datestart);
            that.addmissform.starttime.push(dateend);
            console.log(that.addmissform.starttime);
            //任务课程
            that.addmissform.classarraytwo=''
            that.selectchecktitle=[]
            console.log(that.editlistdata.courses.length);
            that.selectcheckid = []
            for(let i=0;i<that.editlistdata.courses.length;i++){
              that.selectchecktitle.push({
                'no':that.editlistdata.courses[i].no,
                'title':that.editlistdata.courses[i].title,
                'id':that.editlistdata.courses[i].courseid
              })
              that.selectcheckid.push(that.editlistdata.courses[i].courseid)
            }
            this.tablecan=that.selectchecktitle//edit
            // this.addmissform.classarraytwo = that.selectchecktitle;
            that.isshowclassarraytable=true;
            console.log(that.selectchecktitle);
            console.log(this.tablecan);
            // 权限赋值
            that.addmissform.regiontwo=[]
            that.treechecknow=[]
            console.log(that.treechecknow);
            for(var i=0;i<that.editlistdata.structureids.length;i++){
              that.addmissform.regiontwo.push(that.editlistdata.structureids[i])
              that.treechecknow.push(that.editlistdata.structureids[i])//默认选中
              that.treeexpanded.push(that.editlistdata.structureids[i])//默认展开
            }
            console.log(that.treechecknow);
            // console.log(that.treeexpanded);
            //
            that.addmissform.cert=that.editlistdata.icon_name;//证书名称赋值
            //
            this.fileListImage=[]
            this.fileListImage.push({
              'url':that.editlistdata.icon
            });
            this.imgossurl=this.editlistdata.icon;//证书图片赋值
            // id
            that.exidid=that.editlistdata.id;//待编辑的任务id
            if(that.editlistdata.tid==0){
              this.addmissform.train=''
            }else{
              this.addmissform.train = that.editlistdata.tid;
            }

      //   }else{
      //     this.$message({
      //       showClose: true,
      //       message:response.data.msg ,
      //       type: 'error'
      //     });
      //   }
      // }.bind(this))
      // .catch(function (error) {
      //   console.log(error);
      // });
    },
    // 编辑任务
    changemiss(){
      var that=this;
      console.log(this.addmissform.classarraytwo.length);
      console.log(this.tablecan);
      // for(var i=0;i<this.addmissform.classarraytwo.length;i++){
      //   this.tablecan.push({
      //     'no':i+1,
      //     'course_id':this.selectcheckid[i]
      //   });
      // }
      //
      console.log(this.selectchecktitle);
      this.tablecan = []
      for(var i=0;i<this.selectchecktitle.length;i++){
        if(this.selectchecktitle[i].interval==undefined){
          this.selectchecktitle[i].interval='0'
        }
        console.log(this.selectchecktitle[i].interval);
        this.tablecan.push({
          'no':i+1,
          'course_id':this.selectcheckid[i],
          'title':this.selectchecktitle[i].title
        });
      }
      console.log(this.tablecan);
      console.log(this.addmissform.starttime);
      let starttime = this.addmissform.starttime[0]
      let endtime = this.addmissform.starttime[1]
      //时间转时间戳
     var date = new Date(starttime);
     this.begintime = Date.parse(date) / 1000;
     console.log('任务期限开始时间戳：'+this.begintime);

      var date2 = new Date(endtime);
      this.overtime = Date.parse(date2) / 1000;
      console.log('任务期限结束时间戳：'+this.overtime);
      //
      console.log(this.tablecan);
      console.log(this.begintime);
      console.log(this.overtime);
      console.log(this.imgossurl);
      console.log(this.addmissform.regiontwo);
      console.log(that.exidid);
      console.log(that.addmissform.train);
      // this.closeremove()//销毁树
      axios.get('/admin/task/edit', {
        params: {
          sec: localStorage.token,
          title:this.addmissform.name,
          startTime:this.begintime,
          endTime:this.overtime,
          course:JSON.stringify(this.tablecan),
          icon:this.imgossurl,
          iconName:this.addmissform.cert,
          sids:this.addmissform.regiontwo,
          id:that.exidid,
          tid:that.addmissform.train
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.addmisstoast = false;
            this.misslistfun()//任务列表
            this.$message({
              showClose: true,
              message: '修改任务成功',
              type: 'success'
            });
            // 清空表单数据
            this.addmissform.name = '';
            this.addmissform.starttime = '';
            this.addmissform.classarray = '';
            this.addmissform.classarraytwo = '';
            this.addmissform.cert = '';
            this.fileListImage = [];
            this.$refs[addmissform].resetFields();
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    }
  }
}
</script>

<style>
  .x-miss-tabbox .el-tabs__item{
    font-size: 16px;
  }.x-miss-tabbox .el-tabs__nav-wrap::after{
    height: 0;
  }.x-miss-tabbox .el-tabs__nav-wrap{
    margin-left: 10px;
  }.x-pagination{
    margin-top: 20px;
  }.x-misscenlist-box .el-table th.is-leaf{
    text-align: center;
  }.x-misscenlist-box .el-table thead tr th{
    background-color: #F2F2F2;
  }.x-misscenlist-box .el-table td{
    text-align: center;
  }.x-misscenlist-box .el-tabs__nav-wrap::after{
    height: 0;
  }.x-text-see{
    color: #BDA17A;
    text-decoration: none;

  }.x-ac-remove {
      background: url(../images/change.png)no-repeat;
      background-size: contain;
      width: 14px;
      height: 14px;
      vertical-align: bottom;
      padding-left: 25px;
      margin-right: 20px;
  }.x-ac-remove {
    background: url(../images/remove.png)no-repeat;
    background-size: contain;
    color: #FF4D4D;
    cursor: pointer;
  }.x-miss-addbox{
    text-align: left;
    margin-bottom: 15px;
  }.el-form-item__content{
    text-align: left;
  }.x-all-btn {
      margin: 30px 0;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: space-between;
  }.x-btn {
      background-color: #BDA17A;
      font-size: 14px;
      color: #fff;
      text-align: center;
      height: 44px;
      line-height: 44px;
      width: 126px;
      border-radius: 5px;
      cursor: pointer;
      display: inline-block;
      margin-right: 20px;
      z-index: 0;
  }.x-btn-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
  }.x-btn-right .x-search-input{
    width: auto;
    margin-right: 10px;
    /* float: left; */
  }.x-miss-li{
    color: #333;
    cursor: pointer;
  }.x-bianji{

    width: 14px;
    height: 14px;
    vertical-align: bottom;
    padding-left: 25px;
    margin-right: 20px;
    display: initial;
    color: #BDA17A;
    cursor: pointer;
  }.x-person-right{
    background-color: #fff;
    padding: 0 10px;
  }.x-addclass-box{
    padding: 10px;
  }.x-tree-title{
    background-color: #BDA17A;
    color: #fff;
    text-align: center;
    padding: 10px 5px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: block;
  }.x-person-left{
    background-color: #fff;
    height: 800px;
  }.x-tree-title span{
    cursor: pointer;
    border: 1px solid #fff;
    border-radius: 5px;
    padding: 2px;
    width: 80px;
    margin: auto;
    display: block;
    margin-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/missioncenter.vue